import { render, staticRenderFns } from "./OnlineConsultationList.vue?vue&type=template&id=1ba0be05&scoped=true"
import script from "./OnlineConsultationList.vue?vue&type=script&lang=js"
export * from "./OnlineConsultationList.vue?vue&type=script&lang=js"
import style0 from "./OnlineConsultationList.vue?vue&type=style&index=0&id=1ba0be05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0be05",
  null
  
)

export default component.exports